import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Member = ApplicationRecord.extend({
  attrs: {
    capabilities: hasMany({ type: 'staff-capabilities' }),
    email: attr(),
    first_name: attr(),
    last_name: attr(),
    password: attr(),
    password_confirmation: attr(),
  },
  static: {
    endpoint: '/members',
    jsonapiType: 'staff-members',
  },
});

export default Member;
